// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"5f3598f4","479":"142b2174"}[chunkId] + ".chunk.js";
};